import React from 'react';
import { DPage, DPageBody } from '../../../../dum';
import { OrderProductionsListBlock } from './blocks/order-productions-block';

export function OrderProductionsPage() {
    return (
        <DPage animated>
            <DPageBody disableGutters>
                <OrderProductionsListBlock />
            </DPageBody>
        </DPage>
    );
}
